import { useStore } from "@nanostores/react";

import { isPlayerReproduce } from "@/stores/player/playerStore";

import { PlayerAction } from "@/components/shared/player/PlayerAction";
import { PlayerDetail } from "@/components/shared/player/PlayerDetail";
import { PlayerSocialMedia } from "@/components/shared/player/PlayerSocialMedia";
import { PlayerTrackProgress } from "@/components/shared/player/PlayerTrackProgress";

export const PlayerContent = ({ lang }: { lang: "es" | "en" }) => {
  const $isPlayerReproduce = useStore(isPlayerReproduce);
  return (
    <div
      className={`bottom-0 z-50 w-full bg-white-5 px-5 py-4 backdrop-blur-3xl sm:py-5 ${
        $isPlayerReproduce ? "fixed" : "hidden"
      }`}
    >
      <div className="mx-auto flex w-full max-w-[1440px] items-center justify-between">
        <div className="flex-grow">
          <PlayerDetail />
        </div>
        <div className="flex flex-grow justify-center">
          <PlayerAction />
        </div>
        <div className="flex-grow">
          <PlayerSocialMedia lang={lang} />
        </div>
      </div>
      <div className="mt-2 block w-full md:hidden">
        <PlayerTrackProgress />
      </div>
    </div>
  );
};
